import type { Block, Text } from '@ksa/model'
import { SiteText, hasText } from '../context.tsx'

type Props = { eyebrow: Text; heading: Text; subheading: Text; level: string }

/**
 * A section heading.
 *
 * ⚠️ `level` PICKS THE TAG, AND THE TEMPLATE PICKS THE SIZE. They are deliberately not the same
 * choice: a customer who selects "sub-section" because it looks better on the page would otherwise
 * be silently rewriting the document outline a screen reader navigates by. Both levels render at a
 * size the template chose, and only the element changes.
 */
export function HeadingBlock({ block }: { block: Block }) {
  const p = block.props as unknown as Props
  const centered = block.variant === 'centered'
  const Tag = p.level === '3' ? 'h3' : 'h2'

  return (
    <section className="s-section">
      <div className={`s-wrap ${centered ? 's-center s-narrow' : 's-start'}`}>
        {block.variant === 'eyebrow' && hasText(p.eyebrow) && (
          <p className="s-eyebrow" style={{ marginBlockEnd: '0.5rem' }}>
            <SiteText value={p.eyebrow} />
          </p>
        )}
        <Tag className={Tag === 'h3' ? 's-h3' : 's-h2'}>
          <SiteText value={p.heading} />
        </Tag>
        {hasText(p.subheading) && (
          <p className="s-lead" style={{ marginBlockStart: '0.75rem', color: 'var(--muted)' }}>
            <SiteText value={p.subheading} />
          </p>
        )}
      </div>
    </section>
  )
}
